'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/locate/delete.js
// module id = 1677
// module chunks = 0